import React from "react";
import { FormField, CurrencyField, CardSection } from "../../Common/FormComponents";

const UnitPricingSection = ({ formData, handleInputChange }) => {
  const isRental = formData.type === "one_time_rental" || formData.type === "property_management";
  const isSale = formData.type === "sale";

  return (
    <CardSection title="Pricing Information">
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "0.75rem" }}>
        {isRental && (
          <>
            <CurrencyField label="Monthly Rent" name="rent" value={formData.rent} onChange={handleInputChange} />
            <CurrencyField label="Security Deposit" name="deposit" value={formData.deposit} onChange={handleInputChange} />
            <FormField
              label="Utilities"
              name="utilities"
              type="select"
              value={formData.utilities}
              onChange={handleInputChange}
              options={[
                { value: "included", label: "Included in Rent" },
                { value: "tenant_pays", label: "Tenant Pays" },
                { value: "split", label: "Split" },
              ]}
              className="mb-0"
            />
          </>
        )}
        {isSale && (
          <CurrencyField label="Sale Price" name="salePrice" value={formData.salePrice} onChange={handleInputChange} className="mb-0" />
        )}
      </div>
    </CardSection>
  );
};

export default UnitPricingSection;
